import { Error500UI } from "features";

const Error500 = () => {
  return <Error500UI />;
};

export { Error500 };
